import { Card, CardContent, CardHeader, CardTitle } from "alm-react-components";
import moment from "moment-timezone";
import { useTranslation } from "react-i18next";
import { DateFormat } from "../../assets/constants/constants";
import getLocalizedContent from "../../lib/getLocalizedMetaData";
import {
  badgeUrl,
  isEnrollmentDateAvailable,
  weekCountWithOutDoNotShowProgram,
} from "../../lib/utils";
import { PopOverTitle } from "../common/PopOverTitle";

type LearningProgramCardType = {
  cardInfo?: any;
  quater?: string;
  quarterStartDate?: string | Date;
  isEnrollmentOpen?: boolean;
  responseData?: any;
  completed?: any;
};
const LearningProgramCard = (Props: LearningProgramCardType) => {
  const { t } = useTranslation();
  const content = getLocalizedContent(
    Props.cardInfo?.attributes?.localizedMetadata
  );
  const data = {
    imageUrl: Props.cardInfo?.attributes?.imageUrl,
    cardTitle: content.name,
    bannerUrl: Props.cardInfo?.attributes?.bannerUrl,
    duration: weekCountWithOutDoNotShowProgram(Props.cardInfo),
    LpcreatedDate: Props.cardInfo?.attributes?.dateCreated
      ? moment(Props?.quarterStartDate).format(DateFormat)
      : "",
  };

  return (
    <Card
      className={`w-full sm:w-full cursor-pointer h-auto p-0 border-cardBorder common-card-bg flex overflow-hidden max-md:flex-col`}
    >
      <CardHeader className="flex flex-col p-0 relative space-y-0 h-[211px] overflow-hidden w-full">
        <div className=" flex items-center text-xs ml-4 mt-4 border  p-[3px] absolute top-0 left-0 rounded-md text-white px-1.5 bg-[#181818]">
          <p
            className={`w-[8px] h-[8px] ${
              isEnrollmentDateAvailable(data?.LpcreatedDate)
                ? "rounded-full bg-red-500 circle mt-2 ml-2"
                : "rounded-lg bg-red-500"
            }`}
          ></p>
          <p
            className="mx-2 uppercase text-red-50"
            dangerouslySetInnerHTML={{
              __html: t("Program.liveProgram"),
            }}
          />
        </div>
        {Props?.completed?.map((res: any, index: number) => {
          return res?.id === Props.cardInfo?.id ? (
            <>
              <div
                key={index + "_" + res?.id}
                className="absolute top-4 right-0 flex gap-2 items-center text-xs me-4 mt-4 border bg-[#181818] p-[3px] rounded-md text-white px-1.5"
              >
                <p
                  className={`uppercase text-red-50`}
                  dangerouslySetInnerHTML={{
                    __html: t("Common.completed"),
                  }}
                />
              </div>
            </>
          ) : (
            ""
          );
        })}

        <img
          src={data?.imageUrl}
          alt="No Image"
          className="w-full h-[inherit] object-cover object-center bg-center lg:col-span-full rounded-xl rounded-tr-none rounded-b-none"
        />
      </CardHeader>
      <CardContent className="p-6 pt-0 px-6 mt-6 xl:min-h-36 lg:min-h-full w-[inherit] relative">
        <div className="flex flex-row justify-between">
          <CardTitle className="text-wrap lg:text-xl xl:text-2xl font-barlowMedium">
            {data?.cardTitle}
          </CardTitle>
          <PopOverTitle name={data?.cardTitle} />
          <img
            src={badgeUrl(
              Props?.cardInfo?.relationships?.instances?.data[0]?.id,
              Props?.responseData.included
            )}
            alt="No image"
            className={`${
              Props.isEnrollmentOpen ? "yellow" : ""
            } w-[85px] h-[59px] basis-[content]`}
          />
        </div>
        <div className="flex mt-5 text-base font-opensansLight">
          <span className="capitalize">{data?.LpcreatedDate} </span>
          <div className="flex-col">
            <div
              className="ms-2"
              dangerouslySetInnerHTML={{
                __html: `${data?.duration} ${
                  data?.duration > 1 ? t("Common.part") : t("Common.parts")
                }`,
              }}
            ></div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default LearningProgramCard;
